var _path, _path2, _g, _path3, _path4, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultUserImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 202,
    viewBox: "0 0 181 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 181,
    height: 202
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.016 0H0.984375V201.068H180.016V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8_690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 181,
    height: 202
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180.016 0H0.984375V201.068H180.016V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8_690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1185 0H163.882C172.784 0 180.016 7.21026 180.016 16.0865V184.981C180.016 193.858 172.784 201.068 163.882 201.068H17.1185C8.21597 201.068 0.984375 193.858 0.984375 184.981V16.0865C0.984375 7.2048 8.21597 0 17.1185 0Z",
    fill: "#2B3E2B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8_690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 181,
    height: 202
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9377 0C8.11188 0.0928594 0.984375 7.25942 0.984375 16.0865V184.987C0.984375 193.869 8.20501 201.073 17.1185 201.073H163.882C172.79 201.073 180.016 193.874 180.016 184.987V16.0865C180.016 7.26488 172.888 0.0983217 164.062 0H16.9377Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8_690)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_8_690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -10,
    y: 17,
    width: 201,
    height: 190
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M191 17.0479H-10V207H191V17.0479Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_8_690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.4968 26.3447C102.434 26.3447 113.879 31.0751 122.321 39.4871C130.764 47.9045 135.508 59.3207 135.508 71.2177C135.508 83.1146 130.764 94.5363 122.321 102.948C113.879 111.366 102.434 116.091 90.4968 116.091C78.5592 116.091 67.1092 111.36 58.6723 102.948C50.23 94.5308 45.4911 83.1201 45.4911 71.2177C45.4911 59.3153 50.2354 47.9045 58.6723 39.4871C67.1146 31.0696 78.5592 26.3447 90.4968 26.3447ZM90.4968 138.53C140.23 138.53 180.514 158.609 180.514 183.403V205.842H0.485352V183.403C0.485352 158.609 40.7686 138.53 90.5023 138.53",
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUserImage);
export default __webpack_public_path__ + "static/media/default-user-image.380e309569f623eb7e1378948af2f703.svg";
export { ForwardRef as ReactComponent };